import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { CommunicationTypeComponent } from './communication-type/communication-type.component';
import { CommunicationComponent } from './communication/communication.component';
import { CommuncationDocumentComponent } from './communcation-document/communcation-document.component';
import { DocumentsUploadingComponent } from './documents-uploading/documents-uploading.component';
import { ThoughtDayComponent } from './thought-day/thought-day.component';
import { QuestionAnswerComponent } from './question-answer/question-answer.component';
import { ExamAlertComponent } from './exam-alert/exam-alert.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
       { path: 'communicationtype', component: CommunicationTypeComponent, pathMatch: 'full' },
       { path: 'communication', component: CommunicationComponent, pathMatch: 'full' },
       { path: 'communcationdocument', component: CommuncationDocumentComponent, pathMatch: 'full' },
       { path: 'documentsuploading', component: DocumentsUploadingComponent, pathMatch: 'full' },
       { path: 'thought-day', component: ThoughtDayComponent, pathMatch: 'full' },
       { path: 'question-answer', component: QuestionAnswerComponent, pathMatch: 'full' },
       { path: 'exam-alert', component: ExamAlertComponent, pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommunicationRoutingModule { }
